export default "__VITE_ASSET__0d4f99f2__"